import React, { useState, useEffect, useRef } from "react";
import { Card, CardBody, Table, Row, Col, Button } from "reactstrap";
import WorkflowHit from "./Hit";
import WorkflowForm from "./WorkflowForm";
import WorkflowEditor from "./WorkflowEditor";
import MappingEditor from "./MappingEditor";
import Notifications from "../commons/Notifications";
import { fetchWorkflows } from "./Axios";

const WorkflowsIndex = ({ workflows = [] }) => {
  const [workflowList, setWorkflowList] = useState(workflows);
  const [selectedWorkflow, setSelectedWorkflow] = useState(null);
  const [selectedMapping, setSelectedMapping] = useState(null);
  const [view, setView] = useState("recruiter");

  const notifications = useRef(null);

  useEffect(() => {
    loadWorkflows();
  }, [view]);

  const loadWorkflows = () => {
    fetchWorkflows(view)
      .then(setWorkflowList)
      .catch(() => notifications.current?.addNotifications("Error", "No se pudieron cargar los Workflows", "danger"));
  };

  const handleOpenMapping = (mapping) => {
    if (mapping) setSelectedMapping(mapping);
  };

  const showNotification = (title, message, type) => {
    notifications.current?.addNotifications(title, message, type);
  };

  return (
    <>
      <Notifications ref={notifications} />
      {!selectedWorkflow && !selectedMapping ? (
        <>
          <Card className="mb-4 bg-light">
            <CardBody>
              <Row className="align-items-center">
                <Col md="6" className="text-left d-block mb-1 d-flex align-items-center">
                  <i className="fas fa-project-diagram me-2 fa-lg"></i>
                  <h3 className="h4 mb-0 d-inline-block">Gestión de Workflows</h3>
                </Col>
                <Col md="6" className="text-end">
                  <WorkflowForm
                    buttonText="Nuevo Workflow"
                    reloadWorkflows={loadWorkflows}
                    showNotification={showNotification}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Row className="align-items-center justify-content-between">
            <Col md="4">
              <div className="btn-group mb-4">
                <Button
                  color="primary"
                  outline
                  className={view === "recruiter" ? "active btn-primary text-white" : ""}
                  onClick={() => { setView("recruiter"); loadWorkflows(); }}
                >
                  Reclutador
                </Button>
                <Button
                  color="primary"
                  outline
                  className={view === "candidate" ? "active btn-primary text-white" : ""}
                  onClick={() => { setView("candidate"); loadWorkflows(); }}
                >
                  Candidatos
                </Button>
              </div>
            </Col>
          </Row>
          <Card>
            <CardBody>
              <Table>
                <thead>
                <tr>
                  <th>#</th>
                  <th>Nombre</th>
                  <th>Tipo</th>
                  <th className="text-end">Acciones</th>
                </tr>
                </thead>
                <tbody>
                {workflowList.length > 0 ? (
                  workflowList.map((workflow, index) => (
                    <WorkflowHit
                      key={workflow.id}
                      index={index + 1}
                      workflow={workflow}
                      reloadWorkflows={loadWorkflows}
                      showNotification={showNotification}
                      onSelect={() => setSelectedWorkflow(workflow)}
                      onMap={handleOpenMapping}
                    />
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">No hay Workflows disponibles.</td>
                  </tr>
                )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </>
      ) : selectedWorkflow ? (
        <WorkflowEditor workflow={selectedWorkflow} onClose={() => setSelectedWorkflow(null)} />
      ) : (
        <MappingEditor mapping={selectedMapping} onClose={() => setSelectedMapping(null)} onWorkflowUpdate={loadWorkflows} />
      )}
    </>
  );
};

export default WorkflowsIndex;
